import "./App.css";
import Header from "./components/HeaderFiles/Header";
import Sidebar from "./components/SideBar/Sidebar";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import SeeOrder from "./components/SeeOrders/SeeOrder";
import ManageHologram from "./components/ManageHologram/ManageHologram";
import Shivalik from "./components/Shivalik/Shivalik";
import HologramDetail from "./components/HologramDetails/HologramDetail";
import Outbound from "./components/Outbound/Outbound";
import Printing from "./components/Printing/Printing";
import Manageprint from "./components/Manageprinting/Manageprint";
import Invoice from "./components/Invoice/Invoice";
import Sticker from "./components/Sticker/Sticker";
import CreatePrintingPress from "./components/PrintingPressList/PrintingPressList";
import DispatchChallan from "./components/DispatchChallan/DispatchChallan";
import ManageDispatchChallan from "./components/ManageDispatchChallan/ManageDispatchChallan";
import Manageinvoice from "./components/Manageinvoice/Manageinvoice";
import Payments from "./components/PaymentsDone/PaymentsDone";
import Manageprintingpress from "./components/Manageprintingpress/Manageprintingpress";
import Managescan from "./components/Managescan/Managescan";
import Quickhashing from "./components/Quickoutbound/Quickhashing";

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Header />
        <Sidebar />
        <Routes>
          <Route path="Quickhashing" element={<Quickhashing />} />
          <Route path="Managescan" element={<Managescan />} />
          <Route path="Manageprintingpress" element={<Manageprintingpress />} />
          <Route path="Manageinvoice" element={<Manageinvoice />} />
          <Route path="/" element={<Printing />} />
          <Route path="Sticker" element={<Sticker />} />
          <Route path="Invoice" element={<Invoice />} />
          <Route path="SeeOrder" element={<SeeOrder />} />
          <Route path="Manageprint" element={<Manageprint />} />
          <Route path="Printing" element={<Printing />} />
          <Route path="ManageHologram" element={<ManageHologram />} />
          <Route path="HologramDetail" element={<HologramDetail />} />
          <Route path="Outbound" element={<Outbound />} />
          <Route path="CreatePrintingPress" element={<CreatePrintingPress />} />
          <Route path="DispatchChallan" element={<DispatchChallan />} />
          <Route
            path="ManageDispatchChallan"
            element={<ManageDispatchChallan />}
          />
          <Route path="Payments" element={<Payments />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
